module.exports = __webpack_public_path__ + "static/nrf-7cb8691bebbd7fd86b84b81aaea16e67.jpg";